import { axiosInstance } from "../../../axios/axiosInstance";

const API_CUSTOMERS_URL = "admin/customers";
const API_CUSTOMERS_MODULE_LIST_URL = API_CUSTOMERS_URL + "/list";
const API_UPDATE_CUSTOMER_MODULE_STATUS_URL = API_CUSTOMERS_URL + "/update-status";
const API_CUSTOMERS_INFO_BY_ID_URL = API_CUSTOMERS_URL + "/view";


export const getCustomers = (dataToBeSent) => {
  return axiosInstance.get(`${API_CUSTOMERS_MODULE_LIST_URL}?page=${dataToBeSent?.page || ""}&limit=${dataToBeSent?.limit || ""}${dataToBeSent?.role ? `&role=${dataToBeSent?.role}` : ""}&search=${dataToBeSent?.search || ""}&filters[country]=${dataToBeSent?.country || ""}`);
};

export const getCustomerInfoById = (dataToBeSent) => {
  return axiosInstance.get(API_CUSTOMERS_INFO_BY_ID_URL + "/" + dataToBeSent?.selectedCustomerId);
};

export const updateCustomerStatus = ({selectedCustomerId, ...rest}) => {
  return axiosInstance.patch(API_UPDATE_CUSTOMER_MODULE_STATUS_URL + "/" + selectedCustomerId, {...rest});
};